import { render, staticRenderFns } from "./Vocabularies.vue?vue&type=template&id=58a924dd&scoped=true"
import script from "./Vocabularies.vue?vue&type=script&lang=js"
export * from "./Vocabularies.vue?vue&type=script&lang=js"
import style0 from "./Vocabularies.vue?vue&type=style&index=0&id=58a924dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a924dd",
  null
  
)

export default component.exports